
// FOLLOWING SETTINGS WILL BE USED FOR DEV site  ******* appsdev.skfilluminate.net
import {extend} from 'lodash';
import {EnvironmentBaseService} from "src/environments/environment-base.service";

export const environment = extend(EnvironmentBaseService, {
  siteenv: 'prod',
  listDataS3Bucket: 'skf-list-data-prod',
  fileUploadS3Bucket: 'skf-amer-bi-prod',
  sapFileMerge: 's3-sftp-prd-sepcanada',
  webAppFilesS3Bucket: 'skf-upload-files-web-apps-auto',
  impersonateUsers: 'KW3257,manju.reddy@skfvertevo.com,Malarvizhi.palanivel@skfvertevo.com',
  APIEndpoint: 'https://pa950hqnle.execute-api.us-east-1.amazonaws.com/Stage',
  APIEndpointMariaDB: 'https://kgdol3budc.execute-api.us-east-1.amazonaws.com/Stage',
  APIEndPointImportAllocation:"https://hjdebiacce.execute-api.us-east-1.amazonaws.com/Stage",
  APISnowflakeEndpoint: 'https://1qffx886ga.execute-api.us-east-1.amazonaws.com/Prod',
  loginurl: 'https://us-east-1rzegmgndi.auth.us-east-1.amazoncognito.com/login?client_id=2700lgf72i9s87b36pee7a2cid&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fapps.skfautoilluminate.net'
});
